<template>
  <div id="app">
    <el-container class="container">
      <el-header :class="{ headerActive: headerActive == 1 }">
        <div class="menu-content">
          <div class="menu-left" @click="logoClick">
            <!-- 导航栏公司logo -->
            <img src="./assets/home_bannar/logo.png" alt="" class="logo-img" />
          </div>
          <div class="menu-right">
            <div class="menu-box">
              <div class="menu-ul">
                <div
                  v-for="(item, index) in menuItems"
                  :key="item.id"
                  class="menu-li"
                  @click.stop="handleClickOne(item)"
                  @mouseenter="submenuShowControl(index)"
                  @mouseleave="clearSubmenuShowControl()"
                >
                  <div
                    :class="{
                      'menu-li-text': true,
                      active: activeIndex === item.visitPath,
                    }"
                  >
                    {{ item.channelName }}
                    <div
                      :class="{ submenuShow: this.submenuIndex == index }"
                      v-if="item.children && item.children.length > 0"
                      class="submenu"
                    >
                      <div
                        class="submenu-item"
                        v-if="item.id == 24 || item.id == 25"
                      >
                        <div class="submenu-item-innerbox">
                          <div
                            class="submenuMainDispaly"
                            v-for="subItem in item.children"
                            :key="subItem.id"
                            @click.stop="handleClickTwo(subItem)"
                            @mouseenter="thirdMenuShowControl(subItem.id)"
                            @mouseleave="clearThirdmenuShowControl()"
                          >
                            <div class="submenu-main-title">
                              {{ subItem.channelName }}
                              <div class="thirdMenu">
                                <div
                                  class="thirdMenu-main-item"
                                  v-for="thirdItem in subItem.children"
                                  :key="thirdItem.id"
                                  @click.stop="handleClickThree(thirdItem)"
                                >
                                  <div class="thirdMenu-main-item-title">
                                    {{ thirdItem.title }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="submenu-item-open"></div>
                      </div>
                      <!-- v-if="item.id == 26 || item.id == 27 || item.id == 74"-->
                      <div
                        class="submenu-item-two"
                        v-if="item.id == 26 || item.id == 27"
                      >
                        <div class="submenu-item-innerbox">
                          <div
                            class="submenuMainDispaly"
                            v-for="subItem in item.children"
                            :key="subItem.id"
                            @click.stop="handleClickTwo(subItem)"
                            @mouseenter="thirdMenuShowControl(subItem.id)"
                            @mouseleave="clearThirdmenuShowControl()"
                          >
                            <div class="submenu-main-title">
                              {{ subItem.channelName }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="menu-supplier-register">
              <button class="register-btn register-btn--mini" @click="openSupplierRegister">
                <svg
                  class="btn-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                  <path d="M19 8v6M22 11h-6" stroke-width="2.2" />
                </svg>
                <span class="btn-text">供应商入库申请</span>
                <span class="btn-arrow">→</span>
              </button>
            </div>
            <div class="menu-search">
              <div
                @click="SearchClick"
                :class="{
                  'serch-icon': true,
                  serchIconActive: headerActive == 1,
                }"
              >
                <el-icon>
                  <Search />
                </el-icon>
              </div>
              <input
                type="text"
                v-model="serachValue"
                @input="removeSpaces"
                :class="{
                  'search-input': true,
                  searchInputActive: headerActive == 1,
                }"
                @keyup.enter="handleSearch"
              />
            </div>
          </div>
        </div>
      </el-header>
      <el-main ref="mainScroll">
        <div class="right-topUp">
          <div class="right-topUp-top" @click="callUsClick">
            <div class="top-one">
              <img src="./assets/home_bannar/置顶邮箱.svg" alt="" />
            </div>
            <div class="top-line"></div>
            <div class="top-two">
              <img src="./assets/home_bannar/置顶电话.svg" alt="" />
            </div>
          </div>
        </div>
        <router-view></router-view>
        <SupplierRegisterModal v-model="supplierRegisterVisible" />
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { getnavigation, getFoot } from "../src/api/common";
import { events } from "../src/utils/bus";
import { ElMessage } from "element-plus";
import SupplierRegisterModal from "./components/SupplierRegisterModal.vue";

export default {
  name: "app",
  components: {
    SupplierRegisterModal,
  },
  data() {
    return {
      menuItems: [],
      contentListZhbg: [],
      activeIndex: "/", // 默认没有激活的菜单项
      serachValue: "", //搜索框的内容
      headerActive: 0,
      webSiteURl: "",
      submenuIndex: null,
      thirdMenuIndex: null,
      thirdMenuShow: null, //鼠标放在导航时，默认显示二级菜单的第一个
      callUsObj: null,
      rafId: Number,
      supplierRegisterVisible: false,
    };
  },
  created() {
    this.getnavigationData();
    events.on("activeIndex", (value) => {
      //因为informationPersonMap.vue是联系我们，也要点亮一级导航。二级导航和一级导航不一致
      this.activeIndex = value.replace("Map", "");
      this.serachValue = "";
      window.scrollTo({
        top: 0,
      });
    });
    events.on("activeClass", (value) => {
      this.headerActive = value;
    });
    events.on("openSupplierRegister", () => {
      this.openSupplierRegister();
    });
    this.getFootData();
  },
  methods: {
    //获取首页所有数据
    getnavigationData() {
      getnavigation().then((res) => {
        this.menuItems = res.data.navigation.map((item) => {
          //if (item.visitPath == "/" || item.visitPath == "/groupDynamics") {
          if (item.visitPath == "/") {
            item.children = null;
          }
          return item;
        });
      });
    },
    //获取底部信息
    getFootData() {
      getFoot().then((res) => {
        this.artSite = res.data.artSite;
        this.webSiteURl = res.data.artSite.webSite;
      });
    },
    //logo点击
    logoClick() {
      this.$nextTick(() => {
        this.$router.push("/");
        this.activeIndex = "/";
        window.scrollTo(
          {
            top: 0,
          },
          1
        );
      });
    },
    //右侧联系我们图标点击
    callUsClick() {
      this.menuItems.forEach((item) => {
        if (item.id == 27) {
          this.callUsObj = item.children[1];
        }
      });
      this.$router.push({
        path: this.callUsObj.visitPath,
        query: {
          id: this.callUsObj.parentId,
          //subId: this.callUsObj.id,
        },
        hash: "#" + this.callUsObj.sortNum,
      });
    },

    //一级导航点击
    handleClickOne(item) {
      if (item.linkType == 0) {
        if (item.visitPath == "/") {
          this.$router.push({
            path: item.visitPath,
          });
        } else {
          this.$router.push({
            path: item.visitPath,
            query: {
              id: item.id,
            },
          });
        }
      } else {
        window.open(item.visitPath, "_blank");
      }
      this.activeIndex = item.visitPath;
    },
    // 二级导航点击
    handleClickTwo(subItem) {
      if (subItem.linkType == 0) {
        if (subItem.visitPath == "/companyIntroduction") {
          this.$router.push({
            path: subItem.visitPath,
            query: {
              id: subItem.parentId,
              //subId: subItem.id,
            },
            hash: "#" + subItem.sortNum,
          });
        } else {
          this.$router.push({
            path: subItem.visitPath,
            query: {
              id: subItem.parentId,
              subId: subItem.id,
            },
          });
        }
      } else {
        window.open("/", "_blank");
      }
    },
    // 三级导航
    handleClickThree(thirdItem) {
      if (thirdItem.linkType == 0) {
        this.$router.push({
          path: thirdItem.linkUrl,
          query: {
            id: thirdItem.id,
            channelId: thirdItem.channelId,
          },
        });
      } else {
        window.open(thirdItem.linkUrl, "_blank");
      }
    },

    submenuShowControl(index) {
      this.submenuIndex = index;
      this.thirdMenuShow = 1;
    },
    clearSubmenuShowControl() {
      this.submenuIndex = null;
      this.thirdMenuShow = null;
    },
    thirdMenuShowControl(subItemId) {
      this.thirdMenuIndex = subItemId;
    },
    clearThirdmenuShowControl() {
      this.thirdMenuIndex = null;
    },
    removeSpaces() {
      // 使用正则表达式替换空格
      this.serachValue = this.serachValue.replace(/\s/g, "");
    },
    search(title) {
      if (title == undefined || title == "") {
        ElMessage({
          message: "请输入搜索内容!",
          type: "error",
        });
      } else {
        this.$router.push({
          path: "/search",
          query: {
            title: title,
          },
        });
      }
    },
    SearchClick() {
      this.search(this.serachValue);
    },
    handleSearch() {
      this.search(this.serachValue);
    },
    openSupplierRegister() {
      this.supplierRegisterVisible = true;
    },
  },
};
</script>

<style lang="scss">
html,
body {
  width: 100%;
  margin: 0;
  font-family: "Microsoft YaHei", "微软雅黑", Source Han Sans, sans-serif;
}

/* 搜索框去除边框 */
input,
button,
select {
  border: 0px;
  /* 设置背景颜色为透明 */
  background-color: transparent;
  /* 去掉外轮廓 */
  outline: none;
}

/* 去掉a的下划线 */
a {
  text-decoration: none;
}

/* 图片的空白间隙 */
img {
  vertical-align: middle;
}

#app {
}

.container {
  display: flex;
  flex-direction: column;
}

.el-header {
  color: #fff;
  text-align: center;
  position: fixed;
  width: 100%;
  height: 100px !important;
  top: 0;
  z-index: 999;
  padding: 0 80px 0 80px !important;
  border-bottom: 2px solid #ffffff;
  background: rgba(255, 255, 255, 1);
  backdrop-filter: blur(24px);
  box-shadow: 0px 2px 10px 0px rgba(5, 39, 83, 0.1);
}
.el-main {
  padding: 0 !important;
  background-color: #ffffff;
  color: #333;
  text-align: center;
  flex: 1;
  overflow-y: auto;
  height: 100vh;
  box-sizing: border-box;
  z-index: 2;
}

//右侧悬浮联系人
.right-topUp {
  position: fixed;
  right: 60px;
  bottom: 100px;
  // bottom: 180px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  transform: scale(0.6);
  .right-topUp-top {
    width: 60px;
    height: 160px;
    border-radius: 30px;
    padding: 30px 10px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.3);
    border: 1px solid #ffffff;
    backdrop-filter: blur(10px);
    box-shadow: 0px 8px 24px 0px rgba(5, 39, 83, 0.1);
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    .top-one {
      width: 28px;
      height: 28px;
      overflow: hidden;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .top-line {
      width: 32px;
      height: 1px;
      border-top: 1px solid rgba(194, 194, 194, 0.5);
    }
    .top-two {
      width: 28px;
      height: 28px;
      overflow: hidden;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
.top-one:hover,
.top-two:hover {
  img {
    position: relative;
    left: -200px;
    filter: drop-shadow(#a18d64 200px 0);
  }
}
//menu菜单
.menu-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .menu-left {
    cursor: pointer;
    z-index: 2;
    width: 328px;
    height: 38px;
    .logo-img {
      width: 100%;
      height: 100%;
    }
  }
  .menu-right {
    display: flex;
    align-items: center;
    height: 100%;
    .menu-box {
      display: flex;
      align-items: center;
      height: 100%;
      .menu-ul {
        display: flex;
        align-items: center;
        height: 100%;
        .menu-li {
          height: 100%;
          font-size: 18px;
          color: #3d3d3d;
          padding: 0px 30px;
          line-height: 100px;
          cursor: pointer;
          transition: border-color 0.3s ease;
          .menu-li-text {
            height: 100%;
            border-bottom: 4px solid transparent;
            .submenu {
              position: absolute;
              width: 100vw;
              left: -80px;
              top: 95%;
              line-height: 20px;
              box-sizing: border-box;
              display: flex;

              background: rgb(255, 255, 255);
              overflow: hidden;
              visibility: hidden;
              transition: margin-top 0.5s ease-in-out;

              .submenu-item {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                .submenu-item-innerbox {
                  text-align: left;
                  .submenuMainDispaly {
                    padding: 5px 0px;
                    cursor: pointer;
                    display: flex;
                    align-items: left;
                    .submenu-main-title {
                      font-size: 14px;
                      font-family: "Microsoft YaHei", "微软雅黑",
                        Source Han Sans, sans-serif;
                      font-weight: 600;
                      line-height: 24px;
                      color: #3d3d3d;

                      //三级菜单
                      .thirdMenu {
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 14px;
                        line-height: 28px;
                        color: rgba(61, 61, 61, 0.7);
                        font-weight: 400;
                        .thirdMenu-main-item {
                          margin-right: 50px;
                        }
                        .thirdMenu-main-item:hover {
                          color: #a18d64;
                        }
                      }
                    }
                  }
                  .submenuMainDispaly:hover {
                    .submenu-main-title {
                      color: #a18d64;
                    }
                  }
                }
                .submenu-item-open {
                  width: 100%;
                  height: 10px;
                }
              }
              //无三级菜单
              .submenu-item-two {
                width: 100%;
                .submenu-item-innerbox {
                  display: flex;
                  justify-content: center;
                  .submenuMainDispaly {
                    padding: 30px 40px;
                    cursor: pointer;
                    align-items: left;
                    .submenu-main-title {
                      font-size: 16px;
                      font-family: "Microsoft YaHei", "微软雅黑",
                        Source Han Sans, sans-serif;
                      font-weight: 520;
                      line-height: 24px;
                      color: #3d3d3d;
                    }
                  }
                  .submenuMainDispaly:hover {
                    .submenu-main-title {
                      color: #a18d64;
                    }
                  }
                }
              }
            }
            .submenuShow {
              visibility: visible;
              margin-top: 5px;
              transition: margin-top 0.5s ease-in-out;
            }
          }
          .menu-li-text:hover {
            font-weight: 520;
            color: #a18d64;
          }
          .active {
            border-color: #a18d64;
            font-weight: 520;
            color: #a18d64;
          }
        }
      }
    }
    .menu-search {
      position: relative;
      .search-input {
        font-size: 16px;
        width: 240px;
        height: 40px;
        border-radius: 40px;
        border: 2px solid #dcdcdc;
        padding-left: 40px;
        margin-left: 40px;
        background: rgba(255, 255, 255, 0.1);
        box-sizing: border-box;
      }

      .serch-icon {
        font-size: 18px;
        display: flex;
        align-items: center;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        margin-left: 60px;
        color: #dcdcdc;
      }
    }
    .menu-supplier-register {
      margin-left: 16px;
      margin-right: 10px;
      display: flex;
      align-items: center;
      height: 100%;
    }
  }
}

:root {
  --gold: #c8a45a;
  --gold-light: #e2c27d;
  --gold-dark: #a07830;
  --navy: #1a2540;
  --navy-light: #243052;
  --cream: #f8f4ed;
  --text-dark: #1c1c1e;
  --text-muted: #6b6b6e;
  --border: #e0d6c4;
  --success-green: #2d7a4f;
  --shadow-gold: rgba(200, 164, 90, 0.25);
}

.register-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 36px;
  background: linear-gradient(135deg, var(--navy) 0%, var(--navy-light) 100%);
  color: var(--gold-light);
  font-family: "Microsoft YaHei", "微软雅黑", Source Han Sans, sans-serif;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 3px;
  border: none;
  cursor: pointer;
  outline: none;
  text-decoration: none;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  clip-path: polygon(8px 0%, 100% 0%, calc(100% - 8px) 100%, 0% 100%);
  box-shadow: 0 4px 20px rgba(26, 37, 64, 0.3),
    inset 0 1px 0 rgba(200, 164, 90, 0.2);
}

.register-btn::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, var(--gold-dark), var(--gold));
  clip-path: polygon(8px 0%, 100% 0%, calc(100% - 8px) 100%, 0% 100%);
  opacity: 0;
  transition: opacity 0.35s ease;
}

.register-btn:hover::before {
  opacity: 1;
}

.register-btn:hover {
  color: var(--navy);
  box-shadow: 0 8px 32px var(--shadow-gold), 0 2px 8px rgba(26, 37, 64, 0.2);
  transform: translateY(-2px);
}

.register-btn .btn-icon {
  width: 18px;
  height: 18px;
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

.register-btn .btn-text {
  position: relative;
  z-index: 1;
}

.register-btn .btn-arrow {
  position: relative;
  z-index: 1;
  font-size: 14px;
  transition: transform 0.3s ease;
}

.register-btn:hover .btn-arrow {
  transform: translateX(4px);
}

.register-btn--mini {
  padding: 10px 22px;
  font-size: 13px;
  letter-spacing: 2px;
}

.register-btn--mini .btn-icon {
  width: 16px;
  height: 16px;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 20, 35, 0.72);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.4s ease;
  padding: 20px;
}

.modal-overlay.active {
  opacity: 1;
  pointer-events: all;
}

.register-modal {
  background: #fff;
  width: 100%;
  max-width: 480px;
  position: relative;
  transform: translateY(30px) scale(0.97);
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.28),
    0 0 0 1px rgba(200, 164, 90, 0.15);
}

.modal-overlay.active .register-modal {
  transform: translateY(0) scale(1);
}

.modal-top-bar {
  height: 4px;
  background: linear-gradient(
    90deg,
    var(--gold-dark),
    var(--gold-light),
    var(--gold-dark)
  );
}

.modal-header {
  padding: 32px 40px 24px;
  background: linear-gradient(135deg, var(--navy) 0%, var(--navy-light) 100%);
  position: relative;
  overflow: hidden;
}

.modal-header::before {
  content: "";
  position: absolute;
  top: -40px;
  right: -40px;
  width: 120px;
  height: 120px;
  border: 1px solid rgba(200, 164, 90, 0.12);
  border-radius: 50%;
}

.modal-header::after {
  content: "";
  position: absolute;
  top: -20px;
  right: -20px;
  width: 80px;
  height: 80px;
  border: 1px solid rgba(200, 164, 90, 0.18);
  border-radius: 50%;
}

.modal-header-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.logo-emblem {
  width: 36px;
  height: 36px;
  border: 1.5px solid var(--gold);
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(45deg);
  flex-shrink: 0;
}

.logo-emblem-inner {
  width: 16px;
  height: 16px;
  background: var(--gold);
  transform: rotate(0deg);
}

.logo-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.65);
  letter-spacing: 1px;
  line-height: 1.5;
}

.modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 2px;
  margin-bottom: 6px;
}

.modal-subtitle {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 1px;
}

.modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.2s ease;
  z-index: 10;
}

.modal-close:hover {
  border-color: var(--gold);
  color: var(--gold);
  background: rgba(200, 164, 90, 0.1);
}

.modal-body {
  padding: 32px 40px 36px;
}

.notice-bar {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #fdf8ee, #fef9f0);
  border-left: 3px solid var(--gold);
  margin-bottom: 28px;
}

.notice-icon {
  width: 16px;
  height: 16px;
  color: var(--gold-dark);
  flex-shrink: 0;
  margin-top: 1px;
}

.notice-text {
  font-size: 12.5px;
  color: #7a6030;
  line-height: 1.6;
  letter-spacing: 0.3px;
  text-align: left;
}

.notice-text strong {
  color: var(--gold-dark);
  font-weight: 600;
}

.form-group {
  margin-bottom: 20px;
  text-align: left;
}

.form-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: var(--navy);
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}

.form-label .required {
  color: var(--gold-dark);
  margin-left: 2px;
}

.form-input-wrapper {
  position: relative;
}

.form-input {
  width: 100%;
  padding: 12px 44px 12px 44px;
  border: 1.5px solid var(--border);
  background: #fafaf8;
  font-size: 14px;
  color: var(--text-dark);
  outline: none;
  transition: all 0.25s ease;
  letter-spacing: 0.3px;
  border-radius: 0;
  -webkit-appearance: none;
}

.form-input:focus {
  border-color: var(--gold);
  background: #fff;
  box-shadow: 0 0 0 3px rgba(200, 164, 90, 0.1);
}

.form-input::placeholder {
  color: #b0aaa0;
  font-size: 13px;
}

.form-input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: var(--text-muted);
  pointer-events: none;
  transition: color 0.25s ease;
}

.form-input:focus ~ .form-input-icon,
.form-input-wrapper:focus-within .form-input-icon {
  color: var(--gold-dark);
}

.form-input-icon svg {
  width: 16px;
  height: 16px;
}

.password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-muted);
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.password-toggle:hover {
  color: var(--gold-dark);
}

.password-toggle svg {
  width: 16px;
  height: 16px;
}

.strength-bar {
  display: flex;
  gap: 4px;
  margin-top: 8px;
}

.strength-segment {
  height: 3px;
  flex: 1;
  background: #e5dfd5;
  transition: background 0.3s ease;
}

.strength-segment.weak {
  background: #e05a5a;
}

.strength-segment.medium {
  background: #e0a030;
}

.strength-segment.strong {
  background: var(--success-green);
}

.strength-label {
  font-size: 11px;
  color: var(--text-muted);
  margin-top: 4px;
  text-align: right;
}

.form-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--border), transparent);
  margin: 8px 0 20px;
}

.submit-btn {
  width: 100%;
  padding: 15px;
  background: linear-gradient(135deg, var(--navy) 0%, var(--navy-light) 100%);
  color: var(--gold-light);
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 4px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  margin-top: 8px;
}

.submit-btn::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, var(--gold-dark), var(--gold));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.submit-btn:hover::before {
  opacity: 1;
}

.submit-btn:hover {
  color: var(--navy);
  box-shadow: 0 6px 24px var(--shadow-gold);
  transform: translateY(-1px);
}

.submit-btn .btn-inner {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: supplierRegisterSpin 0.7s linear infinite;
  display: none;
}

.submit-btn.loading .spinner {
  display: block;
}

.submit-btn.loading .btn-text {
  display: none;
}

@keyframes supplierRegisterSpin {
  to {
    transform: rotate(360deg);
  }
}

.success-state {
  display: none;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px 0 8px;
  animation: supplierRegisterFadeInUp 0.5s ease forwards;
}

.success-state.show {
  display: flex;
}

@keyframes supplierRegisterFadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.success-icon-wrap {
  width: 72px;
  height: 72px;
  border: 2px solid var(--gold);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  position: relative;
  animation: supplierRegisterSuccessPulse 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)
    forwards;
}

@keyframes supplierRegisterSuccessPulse {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.success-icon-wrap::before {
  content: "";
  position: absolute;
  inset: -8px;
  border: 1px solid rgba(200, 164, 90, 0.25);
}

.success-checkmark {
  width: 32px;
  height: 32px;
  color: var(--gold);
}

.success-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--navy);
  letter-spacing: 2px;
  margin-bottom: 10px;
}

.success-desc {
  font-size: 13px;
  color: var(--text-muted);
  line-height: 1.8;
  margin-bottom: 28px;
  max-width: 300px;
}

.success-actions {
  display: flex;
  gap: 12px;
  width: 100%;
}

.btn-login {
  flex: 1;
  padding: 13px;
  background: linear-gradient(135deg, var(--navy), var(--navy-light));
  color: var(--gold-light);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 3px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.btn-login::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, var(--gold-dark), var(--gold));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.btn-login:hover::before {
  opacity: 1;
}

.btn-login:hover {
  color: var(--navy);
  transform: translateY(-1px);
  box-shadow: 0 6px 20px var(--shadow-gold);
}

.btn-login span {
  position: relative;
  z-index: 1;
}

.btn-close-modal {
  padding: 13px 20px;
  background: transparent;
  color: var(--text-muted);
  font-size: 13px;
  letter-spacing: 1px;
  border: 1.5px solid var(--border);
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-close-modal:hover {
  border-color: var(--navy);
  color: var(--navy);
}

.field-error {
  font-size: 12px;
  color: #d14040;
  margin-top: 6px;
  display: none;
}

.field-error.show {
  display: block;
}

.form-input.error {
  border-color: #d14040;
  box-shadow: 0 0 0 3px rgba(209, 64, 64, 0.08);
}

@media (max-width: 520px) {
  .register-modal {
    max-width: 100%;
  }
  .modal-header {
    padding: 24px 24px 20px;
  }
  .modal-body {
    padding: 24px 24px 28px;
  }
  .success-actions {
    flex-direction: column;
  }
}

.headerActive {
  background: rgba(255, 255, 255, 1) !important;
  box-shadow: 0 0 4px 0px rgba(0, 0, 0, 0.5);
}

.serchIconActive {
  color: rgba(0, 0, 0, 0.7) !important;
}

.searchInputActive {
  border: 1px solid #000 !important;
  color: rgba(0, 0, 0, 0.7) !important;
}

::v-deep .el-icon {
  width: 14px !important;
  height: 14px !important;
}
</style>
<style>
/* 更改分页器样式 */
.el-select-dropdown__item.is-selected {
  color: #a18d64 !important;
}
</style>
